import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function RequestFormWidgetNumber({ 
  disabled, 
  id, 
  label, 
  name,
  onChange, 
  rawErrors, 
  required, 
  value 
}) {
  const intl = useIntl();
  const error = !!(rawErrors && rawErrors.length > 0);

  return (
    <div className="w-full">
      <label 
        className="inline-block text-[calc(6px+0.3vw)] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight" 
        htmlFor={id}
      >
        {intl.formatMessage({ id: label || name || id })}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <input
        type="number"
        step="any"
        disabled={disabled}
        name={id}
        id={id}
        data-cy={id}
        value={value ?? ''}
        onChange={event => {
          const val = event.target.value;
          onChange(val === '' ? undefined : Number(val));
        }}
        style={{ fontWeight: 'normal', color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#212529' }}
        className={classNames(
          "w-full rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] !font-normal font-['Open_Sans'] transition-all focus:outline-none",
          {
            "bg-white": !disabled,
            "!text-[#212529]": !disabled,
            "border-[1px] border-solid border-[#dc3545] focus:border-[#dc3545]": error,
            "border-[1px] border-solid border-[#ced4da] focus:border-[#80bdff]": !error,
            "bg-[#efefef] cursor-not-allowed text-[rgba(0,0,0,0.38)]": disabled
          }
        )}
      />

      {error && (
        <p className="order-form-field-error">
          {rawErrors[0]}
        </p>
      )}
    </div>
  );
}

RequestFormWidgetNumber.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rawErrors: PropTypes.array,
  required: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

RequestFormWidgetNumber.defaultProps = {
  disabled: false,
  rawErrors: [],
  value: undefined,
};

export default RequestFormWidgetNumber;
